<template>
  <a-modal v-model="isVisible" title="Find a club to join" @cancel="close">
    <a-row type="flex" :gutter="1">
      <a-col :xs="18">
        <a-input
          v-model="keyword"
          type="email"
          placeholder="Search for a club"
        ></a-input>
      </a-col>
      <a-col :xs="6">
        <a-button block type="primary" @click="searchClubs">Search</a-button>
      </a-col>
    </a-row>
    <div>
      <a-row v-for="club of clubs" :key="club.id" type="flex" :gutter="4">
        <a-col :span="6">
          {{ club.club_name }}
        </a-col>
        <a-col :span="12"> {{ club.address }}... </a-col>
        <a-col :span="6" class="gx-text-right">
          <a-button
            v-if="
              !club.status ||
                club.status === 'declined' ||
                club.status === 'archived'
            "
            block
            size="small"
            @click="requestToJoin(club.id)"
          >
            Request to Join
          </a-button>
          <a-button
            v-if="
              club.status === 'invited' ||
                club.status === 'accepted' ||
                club.status === 'requested'
            "
            type="danger"
            block
            size="small"
          >
            <template v-if="club.status === 'invited'"
              >Invitation Pending</template
            >
            <template v-if="club.status === 'requested'"
              >Request Sent
            </template>
            <template v-if="club.status === 'accepted'"
              >Already a Member</template
            >
          </a-button>
        </a-col>
      </a-row>
    </div>
    <div slot="footer"></div>
  </a-modal>
</template>

<script>
import notifications from "@/common/notifications/notification.service";
import { clubService } from "@/common/api/api.service";

export default {
  name: "SearchClubsModal",
  props: {
    visible: {
      default: false,
      required: true,
      type: Boolean
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      keyword: "",
      clubs: []
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set() {
        return false;
      }
    }
  },
  methods: {
    requestToJoin(clubId) {
      clubService
        .requestToJoin({
          clubId: clubId
        })
        .then(resp => {
          if (resp.data.success) {
            this.searchClubs();
            notifications.success(
              "We have notified the club, you should hear back soon."
            );
          } else {
            notifications.warn("Something went wrong with this request");
          }
        });
    },
    searchClubs() {
      clubService
        .searchClubs({
          keyword: this.keyword
        })
        .then(resp => {
          if (resp.data.success) {
            this.clubs = resp.data.result;
          }
        });
    },
    close() {
      this.form.resetFields();
      this.$emit("close");
    }
  }
};
</script>
